import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupTwoToneIcon from "@mui/icons-material/GroupTwoTone";
import CategoryIcon from "@mui/icons-material/Category";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import WorkIcon from "@mui/icons-material/Work";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

const SideBarContent = [
  {
    key: "1",
    path: "/dashboard",
    label: "Dashboard",
    icon: <DashboardIcon />,
    roles: ["all"],
  },
  {
    key: "2",
    path: "/dashboard/products",
    label: "Products",
    icon: <CategoryIcon />,
    roles: ["admin", "finance"],
  },
  {
    key: "12",
    label: "Customers",
    icon: <PeopleOutlineIcon />,
    routes: [
      {
        key: "13",
        label: "Find Customers",
        path: "/dashboard/customers/find-customer",
        roles: ["admin", "finance", "ccr"],
      },
      {
        key: "11",
        label: "Customers",
        path: "/dashboard/customers",
        roles: ["admin", "finance", "ccr"],
      },
    ],
    roles: ["admin", "finance", "ccr"],
  },
  {
    key: "7",
    label: "Users",
    icon: <GroupTwoToneIcon />,
    routes: [
      // {
      //   key: "13",
      //   label: "Find Customers",
      //   path: "/dashboard/customers/find-customer",
      //   roles: ["admin", "finance", "ccr"],
      // },
      // {
      //   key: "11",
      //   label: "Customers",
      //   path: "/dashboard/customers",
      //   roles: ["admin", "finance", "ccr"],
      // },
      {
        key: "8",
        label: "All Users",
        path: "/dashboard/users",
        roles: ["admin"],
      },
    ],
    roles: ["admin"],
  },
  // {
  //   key: "3",
  //   path: "/dashboard/inventory",
  //   label: "Inventory",
  //   icon: <InventoryIcon />,
  //   roles: ["supplier", "admin", "finance"],
  // },

  {
    key: "4",
    label: "Loans",
    icon: <VerticalSplitIcon />,
    roles: ["admin", "finance", "customer"],
    routes: [
      {
        key: "5",
        label: "Loans",
        path: "/dashboard/loans",
        roles: ["admin", "finance"],
      },
      {
        key: "6",
        label: "Loan requests",
        path: "/dashboard/loan-requests",
        roles: ["admin", "finance"],
      },
      {
        key: "30",
        label: "User Loans",
        path: "/dashboard/user/user-loans",
        roles: ["customer"],
      },
    ],
  },
  {
    key: "36",
    label: "Guarantorship",
    icon: <PeopleOutlineIcon />,
    // path: "/dashboard/user/user-guarantors",
    roles: ["customer"],
    routes: [
      {
        key: "37",
        label: "Guarantorship",
        path: "/dashboard/user/user-guarantors",
        roles: ["customer"],
      },
      {
        key: "35",
        label: "Guarantor Nominations",
        path: "/dashboard/user/user-guarantor-nominations",
        roles: ["customer"],
      },
    ],
  },
  {
    key: "44",
    label: "Finance",
    icon: <CardTravelIcon />,
    // path: "/dashboard/transactions",
    roles: ["admin", "finance"],
    routes: [
      // {
      //   key: "46",
      //   label: "Petty Cash",
      //   path: "/dashboard/finance/petty-cash-records",
      //   roles: ["admin"],
      // },

      // {
      //   key: "47",
      //   label: "Cheque Approval",
      //   path: "/dashboard/finance/cheque-approvals",
      //   roles: ["admin"],
      // },
      {
        key: "48",
        label: "Disbursements",
        path: "/dashboard/finance/disbursements",
        roles: ["admin", "finance"],
      },
      {
        key: "49",
        label: "Suspense Account",
        path: "/dashboard/finance/suspense-account",
        roles: ["admin", "finance"],
      },
    ],
  },
  // {
  //   key: "50",
  //   label: "Reconciliations",
  //   icon: <PublishedWithChangesIcon />,
  //   // path: "/dashboard/transactions",
  //   roles: ["admin", "finance"],
  //   routes: [
  //     {
  //       key: "51",
  //       label: "Deposits/C2B",
  //       path: "/dashboard/reconciliation/deposits-c2b-recon",
  //       roles: ["admin"],
  //     },
  //     {
  //       key: "52",
  //       label: "Approve Deposits/C2B",
  //       path: "/dashboard/reconciliation/approve-deposits-c2b-recon",
  //       roles: ["admin"],
  //     },
  //     {
  //       key: "53",
  //       label: "Withdraws/B2C",
  //       path: "/dashboard/reconciliation/withdraws-b2c-recon",
  //       roles: ["admin"],
  //     },
  //     {
  //       key: "54",
  //       label: "Reconciliation Status",
  //       path: "/dashboard/reconciliation/recon-status",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  {
    key: "62",
    label: "Sasra Reports",
    icon: <AssessmentIcon />,
    // path: "/dashboard/transactions",
    roles: ["admin", "finance"],
    routes: [
      // {
      //   key: "55",
      //   label: "Savings Report",
      //   path: "/dashboard/sasra/savings-report",
      //   roles: ["admin"],
      // },
      {
        key: "56",
        label: "Loan Portfolio Report",
        path: "/dashboard/sasra/loan-portfolio-report",
        roles: ["admin", "finance"],
      },
      // {
      //   key: "57",
      //   label: "Deposit Return Report",
      //   path: "/dashboard/sasra/deposit-return-report",
      //   roles: ["admin"],
      // },
      // {
      //   key: "58",
      //   label: "Loan Ageing Report",
      //   path: "/dashboard/sasra/loan-ageing-report",
      //   roles: ["admin"],
      // },
      // {
      //   key: "59",
      //   label: "Saving Share Report",
      //   path: "/dashboard/sasra/savings-share-report",
      //   roles: ["admin"],
      // },
      {
        key: "59",
        label: "Extended Share Report",
        path: "/dashboard/sasra/extended-share-report",
        roles: ["admin", "finance"],
      },
      {
        key: "60",
        label: "Extended Savings Report",
        path: "/dashboard/sasra/extended-savings-report",
        roles: ["admin", "finance"],
      },
      // {
      //   key: "61",
      //   label: "Loan Classification",
      //   path: "/dashboard/sasra/loan-classification-report",
      //   roles: ["admin"],
      // },
    ],
  },

  {
    key: "9",
    label: "Transactions",
    icon: <ReceiptIcon />,
    // path: "/dashboard/transactions",
    roles: ["admin", "finance", "customer"],
    routes: [
      {
        key: "31",
        label: "User Transactions",
        path: "/dashboard/user/user-transactions",
        roles: ["customer"],
      },
      {
        key: "34",
        label: "Transactions",
        path: "/dashboard/transactions",
        roles: ["admin", "finance"],
      },
      {
        key: "38",
        label: "Deposits",
        path: "/dashboard/user/user-deposits",
        roles: ["customer"],
      },
      {
        key: "65",
        label: "Deposits",
        path: "/dashboard/transactions/deposits",
        roles: ["admin", "finance"],
      },
      {
        key: "39",
        label: "Savings",
        path: "/dashboard/user/user-savings",
        roles: ["customer"],
      },
      {
        key: "66",
        label: "Savings",
        path: "/dashboard/transactions/savings",
        roles: ["admin", "finance"],
      },
      {
        key: "40",
        label: "Pool Fund",
        path: "/dashboard/user/user-pool-fund-transactions",
        roles: ["customer"],
      },
      {
        key: "67",
        label: "Pool",
        path: "/dashboard/transactions/pool-transactions",
        roles: ["admin", "finance"],
      },
    ],
  },

  {
    key: "32",
    label: "Shares",
    icon: <ReceiptIcon />,
    // path: "/dashboard/transactions",
    roles: ["customer"],
    routes: [
      {
        key: "33",
        label: "Member shares",
        path: "/dashboard/user/user-shares",
        roles: ["customer"],
      },
      {
        key: "41",
        label: "Shares",
        path: "/dashboard/user/user-shares",
        roles: ["admin", "finance"],
      },
    ],
  },
  {
    key: "16",
    label: "Pool Basket",
    icon: <WorkIcon />,
    path: "/dashboard/pool-basket",
    roles: ["admin", "finance"],
  },
  {
    key: "14",
    label: "Withdraw requests",
    icon: <MoveDownIcon />,
    roles: ["admin", "finance", "ccr"],
    routes: [
      {
        key: "14",
        label: "Pool withdraw",
        path: "/dashboard/pool-fund-withdraw-requests",
        roles: ["admin", "finance", "ccr"],
      },
      {
        key: "15",
        label: "Transactions Withdraw",
        path: "/dashboard/transactions-withdraw-requests",
        roles: ["admin", "finance", "ccr"],
      },
    ],
  },
  {
    key: "17",
    label: "Reports",
    icon: <AssessmentIcon />,
    roles: ["admin", "finance"],
    routes: [
      {
        key: "20",
        label: "Registration fees",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/registration-fees",
      },
      {
        key: "21",
        label: "Shares",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/shares",
      },
      {
        key: "22",
        label: "Savings",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/savings",
      },
      // {
      //   key: "23",
      //   label: "Refunds",
      //   roles: ["admin"],
      //   path: "/dashboard/reports/refunds",
      // },
      // {
      //   key: "24",
      //   label: "Commisions paid",
      //   roles: ["admin"],
      //   path: "/dashboard/reports/commission-paid",
      // },
      {
        key: "25",
        label: "Loans given",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/loans-given",
      },
      {
        key: "26",
        label: "Principle repaid",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/principle-repaid",
      },
      {
        key: "27",
        label: "Interest repaid",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/installment-repaid",
      },
      {
        key: "28",
        label: "Rollover installment",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/rollover-installment",
      },
      {
        key: "65",
        label: "Debt Collection",
        roles: ["admin", "finance"],
        path: "/dashboard/reports/debt-collection",
      },
      // {
      //   key: "29",
      //   label: "Recovery",
      //   roles: ["admin", "finance"],
      //   path: "/dashboard/reports/recovery",
      // },
    ],
  },
  {
    key: "63",
    label: "BI Reports",
    icon: <AssessmentIcon />,
    path: "/dashboard/bi-reports",
    roles: ["admin", "finance"],
    // routes: [
    //   {
    //     key: "64",
    //     label: "Registration",
    //     roles: ["admin", "finance"],
    //     path: "/dashboard/bi-reports/registrations",
    //   },
    // ],
  },

  {
    key: "42",
    label: "Settings",
    icon: <SettingsIcon />,
    roles: ["admin", "finance"],
    routes: [
      {
        key: "43",
        label: "System Settings",
        path: "/dashboard/system/settings",
        roles: ["admin"],
      },
      {
        key: "45",
        label: "Bank Accounts",
        path: "/dashboard/system/bank-accounts",
        roles: ["admin", "finance"],
      },
    ],
  },
];

export default SideBarContent;
